import { aMapCoordTransform, getAMapProvider } from '@/env-configs/amap-config'

export default function getAppConfig() {
	return {
		getMapProvider: getAMapProvider,
		coordTransform: aMapCoordTransform
	}
}
